import { Link } from "@medoma/components/Link/Link";
import { useUnreadNotificationCounts } from "@medoma/chat/useUnreadNotificationCounts";
import styles from "./NotificationsCell.module.scss";
import { useQuery } from "@tanstack/react-query";
import { patientsWithUnhandledMeasurementsQueryOptions } from "@/api/Patients";
import UnreadChatMessagesIndicator from "@/components/IconWithIndicator/UnreadChatMessagesIndicator/UnreadChatMessagesIndicator";
import UnhandledMeasurementsIndicator from "@/components/IconWithIndicator/UnhandledMeasurementsIndicator/UnhandledMeasurementsIndicator";

export const NotificationsCell = ({ patientId }: { patientId: string }) => {
  const { data: patientsWithUnhandledMeasurements } = useQuery(
    patientsWithUnhandledMeasurementsQueryOptions,
  );
  const unreadChatNotificationsCount = useUnreadNotificationCounts({
    roomName: patientId,
  });
  const hasUnreadChatMessages =
    unreadChatNotificationsCount !== undefined &&
    unreadChatNotificationsCount > 0;
  const hasUnhandledMeasurements = patientsWithUnhandledMeasurements?.find(
    ({ id, unhandledMeasurementsCount }) =>
      id === patientId && unhandledMeasurementsCount > 0,
  )
    ? true
    : false;

  return (
    <div className={styles.root}>
      <Link to={`/commandcenter/patients/${patientId}/communication`}>
        <UnreadChatMessagesIndicator
          hasUnreadMessages={hasUnreadChatMessages}
          unreadMessagesCount={unreadChatNotificationsCount}
          passiveState="visible"
        />
      </Link>
      <Link to={`/commandcenter/patients/${patientId}/measurements`}>
        <UnhandledMeasurementsIndicator
          hasUnhandledMeasurements={hasUnhandledMeasurements}
          passiveState="visible"
        />
      </Link>
    </div>
  );
};
